import React from "react";
import FilterList from "./FilterList";
import ProviderList from "./ProviderList";
import { useFetchPatientPrimaryProviderMutation } from "../../features/patient/patientApiSlice";

const LeftBar = ({
  onCLickZoomToMarker,
  patients,
  selectedPatients,
  handleSelectedPatients,
  fetchPatients,
  patientsLoading,
  providers,
  selectedProviders,
  handleSelectedProviders,
  fetchProviders,
  providersLoading,
  zones,
  selectedZones,
  handleSelectedZones,
  fetchZones,
  zonesLoading,
  handleApplyFilters,
  providersList,
  providerColors,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const [patientType, setPatientType] = React.useState("All");
  const [selectedProvider, setSelectedProvider] = React.useState(null);
  const [selectedPatient, setSelectedPatient] = React.useState(null);

  const [selectedProviderPatients, setSelectedProviderPatients] =
    React.useState([]);

  const [fetchPatientPrimaryProvider, { isLoading }] =
    useFetchPatientPrimaryProviderMutation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handlePatientType = (data) => {
  //   setPatientType(data);
  // };

  const handleProvider = (data) => {
    if (selectedProvider === data) {
      setSelectedProvider(null);
      return;
    }

    setSelectedProvider(data);
  };

  const handlePatient = (data) => {
    if (selectedPatient === data) {
      setSelectedPatient(null);
      return;
    }

    setSelectedPatient(data);
  };

  const fetchProviderPatients = async () => {
    setSelectedProviderPatients([]);

    const { data } = await fetchPatientPrimaryProvider({
      id: selectedProvider,
      body: {
        patientIds: selectedPatients.map((patient) => patient.value),
        zoneIds: selectedZones.map((zone) => zone.value),
      },
    }).unwrap();

    setSelectedProviderPatients(data);
  };

  const open = Boolean(anchorEl);

  React.useEffect(() => {
    if (selectedProvider) {
      fetchProviderPatients();
    }
  }, [selectedProvider]);

  return (
    <div className="flex flex-col w-3/12 h-[calc(100vh-146px)] border-r border-primarygrayborder overflow-y-auto">
      <FilterList
        // open={open}
        // handleClick={handleClick}
        // patientType={patientType}
        // anchorEl={anchorEl}
        // handleClose={handleClose}
        // handlePatientType={handlePatientType}
        patients={patients}
        selectedPatients={selectedPatients}
        handleSelectedPatients={handleSelectedPatients}
        fetchPatients={fetchPatients}
        patientsLoading={patientsLoading}
        providers={providers}
        selectedProviders={selectedProviders}
        handleSelectedProviders={handleSelectedProviders}
        fetchProviders={fetchProviders}
        providersLoading={providersLoading}
        zones={zones}
        selectedZones={selectedZones}
        handleSelectedZones={handleSelectedZones}
        fetchZones={fetchZones}
        zonesLoading={zonesLoading}
        handleApplyFilters={handleApplyFilters}
      />
      <ProviderList
        handlePatient={handlePatient}
        handleProvider={handleProvider}
        providerColors={providerColors}
        providers={providersList}
        selectedPatient={selectedPatient}
        selectedProvider={selectedProvider}
        onCLickZoomToMarker={onCLickZoomToMarker}
        patients={selectedProviderPatients}
        loading={isLoading}
      />
    </div>
  );
};

export default LeftBar;
